// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (max-width:500px){.single-file-check p[data-v-64ee333c]{font-size:15px!important;color:#ff2d55;font-weight:400}}", ""]);
// Exports
module.exports = exports;
